module.exports = __webpack_public_path__ + "static/img/bookBlankPage.3164631.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bookBlankPage.svg
// module id = xRT+
// module chunks = 1